module.exports = __webpack_public_path__ + "static/media/three-line-menu.5704b467.svg";